__turbopack_context__.v({
  "className": "instrument_sans_abf2674-module__xGa2eq__className",
});
